import { render, staticRenderFns } from "./WeeklyBoard.vue?vue&type=template&id=11dedc38&scoped=true"
import script from "./WeeklyBoard.vue?vue&type=script&lang=js"
export * from "./WeeklyBoard.vue?vue&type=script&lang=js"
import style0 from "./WeeklyBoard.vue?vue&type=style&index=0&id=11dedc38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dedc38",
  null
  
)

export default component.exports